module.exports = __webpack_public_path__ + "img/XAI.6adad79b.svg";